export function compactChaptersForStorage(chapters) {
  return normalizeChapterList(chapters).map((chapter) => {
    const hasCanonicalBlocks =
      Array.isArray(chapter.contentBlocks) && chapter.contentBlocks.length > 0;

    if (chapter.chapterType !== "text" || !hasCanonicalBlocks) {
      return chapter;
    }

    return {
      ...chapter,
      textContent: "",
    };
  });
}

export function normalizeChapterList(value) {
  if (!Array.isArray(value)) return [];
  return value.filter(
    (chapter) => chapter && typeof chapter === "object" && !Array.isArray(chapter)
  );
}

function stableValue(value) {
  if (Array.isArray(value)) {
    return value.map(stableValue);
  }

  if (value && typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        result[key] = stableValue(value[key]);
        return result;
      }, {});
  }

  return value;
}

export function areChapterSnapshotsEqual(localChapters, storedChapters) {
  const local = stableValue(compactChaptersForStorage(localChapters));
  const stored = stableValue(compactChaptersForStorage(storedChapters));
  return JSON.stringify(local) === JSON.stringify(stored);
}

export function confirmChapterDeletion(chapter, confirmFn = window.confirm) {
  const name = chapter?.chapterName || "this chapter";
  return confirmFn(`Delete "${name}"? This cannot be undone.`);
}
